import { useEffect } from 'react';

const SCRIPT_ID = 'page-jsonld';

/**
 * Injects JSON-LD structured data into document head.
 * Replaces previous script on id when data changes (route change).
 */
export function useJsonLd(data: Record<string, unknown> | Record<string, unknown>[] | null) {
  useEffect(() => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    if (!data) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(SCRIPT_ID);
      if (s) s.remove();
    };
  }, [data]);
}
